
import * as types from "../mutation-types";

// state
export const state = {
  logo: localStorage.getItem("logo")
};

// getters
export const getters = {
  logo: state => state.logo
};

// mutations
export const mutations = {
    [types.SAVE_LOGO] (state, { logo, remember }) {
        state.logo = logo
        localStorage.setItem('logo', logo)
      },
};

// actions
export const actions = {
    saveLogo ({ commit, dispatch }, payload) {
        commit(types.SAVE_LOGO, payload)
      },
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/app.js